/*=============================================== Paginator ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Variables from "./Variables";
import Mixins from "./Mixins";
import Input from "./Input";
import Icon from "./Icon";
import FajnyIcon from "./FajnyIcon";
/*==================== Component ====================*/
var Paginator = function (_a) {
    var _b = _a.justify, justify = _b === void 0 ? "left" : _b, _c = _a.textPage, textPage = _c === void 0 ? "Page" : _c, _d = _a.textOf, textOf = _d === void 0 ? "of" : _d, iconPrev = _a.iconPrev, _e = _a.fajnyIconPrev, fajnyIconPrev = _e === void 0 ? "chevron-left-solid" : _e, iconNext = _a.iconNext, _f = _a.fajnyIconNext, fajnyIconNext = _f === void 0 ? "chevron-right-solid" : _f, handlePrev = _a.handlePrev, handleNext = _a.handleNext, handleChange = _a.handleChange, active = _a.active, totalPages = _a.totalPages, _g = _a.idInput, idInput = _g === void 0 ? "paginator" : _g, props = __rest(_a, ["justify", "textPage", "textOf", "iconPrev", "fajnyIconPrev", "iconNext", "fajnyIconNext", "handlePrev", "handleNext", "handleChange", "active", "totalPages", "idInput"]);
    var activePage = active > totalPages ? totalPages : active < 1 ? 1 : active;
    return (React.createElement(Container, { "$justify": justify },
        textPage,
        " ",
        React.createElement(StyledInput, __assign({ type: "number", id: idInput, value: activePage, onChange: handleChange }, props)),
        " ", "".concat(textOf, " ").concat(totalPages),
        React.createElement(Button, { onClick: handlePrev, disabled: activePage === 1 && true }, iconPrev ? React.createElement(Icon, { src: iconPrev, size: 16 }) : React.createElement(FajnyIcon, { name: fajnyIconPrev, size: 16 })),
        React.createElement(Button, { onClick: handleNext, disabled: activePage === totalPages && true }, iconNext ? React.createElement(Icon, { src: iconNext, size: 16 }) : React.createElement(FajnyIcon, { name: fajnyIconNext, size: 16 }))));
};
export default Paginator;
/*==================== Types ====================*/
var justify = {
    left: "left",
    right: "right",
};
/*==================== Styles ====================*/
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var $justify = _a.$justify;
    return Mixins.Flexbox({
        $align: "center",
        $justify: $justify === "right" ? "flex-end" : "flex-start",
        $gap: "xs",
    });
});
var StyledInput = styled(Input)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 48px;\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n    }\n"], ["\n    width: 48px;\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n    }\n"])));
var buttonSize = 24;
var Button = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    padding: 0;\n    ", ";\n    border: none;\n    background-color: transparent;\n    color: ", ";\n    transition: ", ";\n\n    @media ", " {\n        &:not(:disabled):hover {\n            background-color: ", ";\n            color: ", ";\n        }\n\n        &:not(:disabled):active {\n            background-color: ", ";\n        }\n    }\n\n    &:disabled {\n        color: ", ";\n    }\n"], ["\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", ";\n    padding: 0;\n    ", ";\n    border: none;\n    background-color: transparent;\n    color: ", ";\n    transition: ", ";\n\n    @media ", " {\n        &:not(:disabled):hover {\n            background-color: ", ";\n            color: ", ";\n        }\n\n        &:not(:disabled):active {\n            background-color: ", ";\n        }\n    }\n\n    &:disabled {\n        color: ", ";\n    }\n"])), buttonSize, buttonSize, Variables.Radiuses.Circle, Mixins.Flexbox({
    $align: "center",
    $justify: "center",
    $inline: true,
}), Variables.Colors.Primary500, Variables.Transitions.Short, Variables.Breakpoints.Hover, Variables.Colors.Primary300, Variables.Colors.White, Variables.Colors.Primary600, Variables.Colors.Gray500);
var templateObject_1, templateObject_2, templateObject_3;
